var assign = require("lodash/assign");

var pick = require("lodash/pick");

var allowedOptions = ["score_mode", "inner_hits", "min_children", "max_children"];
export function HasChildQuery(type, query) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    has_child: assign({
      type: type,
      query: query
    }, pick(options, allowedOptions))
  };
}